// Init Header JavaScript Elements
window.header.init();
// Init Page Content JavaScript Elements
window.page.init();
// Init Footer JavaScript Elements
window.footer.init();
